var _a;
import { EventSubscriber } from '@verdant-web/common';
import { Entity } from '../entities/Entity.js';
import { Disposable } from '../utils/Disposable.js';
import { filterResultSet } from './utils.js';
export const ON_ALL_UNSUBSCRIBED = Symbol('ON_ALL_UNSUBSCRIBED');
export const UPDATE = Symbol('UPDATE');
// export interface BaseQuery<T> {
// 	subscribe(event: 'change', callback: (value: T) => void): () => void;
// 	subscribe(event: 'statusChange', callback: (status: QueryStatus) => void): () => void;
// 	subscribe(callback: (value: T) => void): () => void;
// }
export class BaseQuery extends Disposable {
    constructor({ initial, context, collection, key, shouldUpdate, }) {
        super();
        this._internalUnsubscribes = [];
        this._status = 'initial';
        this._executionPromise = null;
        this.setValue = (value) => {
            this._rawValue = value;
            this.subscribeToDeleteAndRestore(this._rawValue);
            this._value = filterResultSet(value);
            // validate the value
            if (Array.isArray(this._value) &&
                this._value.some((v) => v.getSnapshot() === null)) {
                debugger;
            }
            this._status = 'ready';
            this._events.emit('change', this._value);
        };
        // re-applies filtering if results have changed
        this.refreshValue = () => {
            this.setValue(this._rawValue);
        };
        this.subscribeToDeleteAndRestore = (value) => {
            var _b;
            while (this._internalUnsubscribes.length) {
                (_b = this._internalUnsubscribes.pop()) === null || _b === void 0 ? void 0 : _b();
            }
            if (Array.isArray(value)) {
                value.forEach((entity) => {
                    if (entity instanceof Entity) {
                        this._internalUnsubscribes.push(entity.subscribe('delete', this.refreshValue));
                        this._internalUnsubscribes.push(entity.subscribe('restore', this.refreshValue));
                    }
                });
            }
            else if (value instanceof Entity) {
                this._internalUnsubscribes.push(value.subscribe('delete', this.refreshValue));
                this._internalUnsubscribes.push(value.subscribe('restore', () => {
                    this.refreshValue();
                }));
            }
        };
        this.execute = () => {
            this.context.log('debug', 'Executing query', this.key);
            if (this._status === 'initial') {
                this._status = 'initializing';
            }
            else if (this._status === 'ready') {
                this._status = 'revalidating';
            }
            // no status change needed if already in a 'running' status.
            this._executionPromise = this.run()
                .then(() => this._value)
                .catch((err) => {
                if (err instanceof Error) {
                    if (err.name === 'InvalidStateError' ||
                        err.name === 'InvalidAccessError') {
                        // possibly accessing db while it's closed. not much we can do.
                        return this._value;
                    }
                    throw err;
                }
                else {
                    throw new Error('Unknown error executing query');
                }
            });
            return this._executionPromise;
        };
        this[_a] = (handler) => {
            this._allUnsubscribedHandler = handler;
        };
        this._rawValue = initial;
        this._value = initial;
        this._events = new EventSubscriber((event) => {
            var _b;
            if (event === 'change')
                (_b = this._allUnsubscribedHandler) === null || _b === void 0 ? void 0 : _b.call(this, this);
        });
        this.context = context;
        this.key = key;
        this.collection = collection;
        const shouldUpdateFn = shouldUpdate ||
            ((collections) => collections.includes(collection));
        this.addDispose(this.context.entityEvents.subscribe('collectionsChanged', (collections) => {
            if (shouldUpdateFn(collections)) {
                this.context.log('info', 'Updating query', this.key);
                // immediately refilter the result set - deleted
                // entities will already be nulled out
                // this.refreshValue();
                this.execute();
            }
        }));
        // TODO: subscribe to document changes and update if necessary.
    }
    get current() {
        return this._value;
    }
    get resolved() {
        var _b;
        if (this.status === 'ready')
            return Promise.resolve(this._value);
        return (_b = this._executionPromise) !== null && _b !== void 0 ? _b : this.execute();
    }
    get subscribed() {
        return this._events.totalSubscriberCount() > 0;
    }
    get status() {
        return this._status;
    }
    subscribe(eventOrCallback, callback) {
        // change subscription has special behavior...
        if (callback === undefined && typeof eventOrCallback === 'function') {
            // accessing for side effects... eh
            this.resolved;
            return this._events.subscribe('change', eventOrCallback);
        }
        else if (eventOrCallback === 'change' && callback !== undefined) {
            // accessing for side effects... eh
            this.resolved;
            return this._events.subscribe('change', callback);
        }
        else if (eventOrCallback === 'statusChange' &&
            typeof callback === 'function') {
            return this._events.subscribe(eventOrCallback, callback);
        }
        else {
            throw new Error('Invalid invocation of Query.subscribe');
        }
    }
}
_a = ON_ALL_UNSUBSCRIBED;
//# sourceMappingURL=BaseQuery.js.map